/*eslint-env node*/

var Module = require("theme_module_loader");
var htmlTemplate = require("./css-block.html");
var callback = function(){};
module.exports = {
    load: function() {
        var args = {
            htmlTemplate: htmlTemplate,
            callback: callback
        };

        return new Module(args);
    }
};



// WEBPACK FOOTER //
// ../includes/css-block/css-block.js